// extracted by css-extract-rspack-plugin
export default {"dialogActions":"eMgSWhLyujApfobQ","dialogBody":"ADKOtSIeZeApc_tW"};